<template>
    <b-container fluid class="p-0">
        <b-form @submit.prevent="handleOK">
            <b-table-simple responsive hover class="rep-table">
                <b-tbody>
                <b-tr class="my-info-h">
                    <b-td class="gray-600 fw-500"> {{$t(`성함`)}} </b-td>
                    <b-td class="text-left"> <div class="ml-2 py-1"> {{ user_name }} </div></b-td>
                </b-tr>
                <b-tr class="my-info-h">
                    <b-td class="gray-600 fw-500"> {{$t(`이메일`)}}</b-td>
                    <b-td class="text-left"> <div class="ml-2 py-1"> {{ e_mail }} </div> </b-td>
                </b-tr>
                <b-tr>
                    <b-td class="gray-600 fw-500"> {{$t(`회사`)}} </b-td>
                    <b-td class=""><div class="w-50 text-left pl-2"> {{ company_name }}  </div>
                    </b-td>
                </b-tr>
                <b-tr>
                    <b-td colspan="2" class="f-85 gray-550 text-left">{{ $t('성함·이메일·회사 변경은 info@qesg.co.kr 로 문의해 주세요.') }}</b-td>
                </b-tr>
                <b-tr>
                    <b-td class="gray-600 fw-500"> {{$t(`전화번호`)}} </b-td>
                    <b-td class="d-md-flex">
                        <b-form-input type='text' v-model="tel_office" :placeholder="$t('사무실 전화')" :aria-label="$t('사무실 전화')"></b-form-input>
                        <b-form-input type='text' v-model="tel_mobile" :placeholder="$t('휴대폰')" :aria-label="$t('휴대폰')" class="ml-md-2"></b-form-input>
                    </b-td>
                </b-tr>
                    <b-tr>
                    <b-td class="gray-600 fw-500"> {{$t(`주소`)}} </b-td>
                    <b-td>
                        <b-form-input type='text' v-model="address" :placeholder="$t(`현재 근무지 주소를 입력해 주세요`)" :aria-label="$t(`주소`)"></b-form-input>
                    </b-td>
                </b-tr>
                <b-tr>
                    <b-td class="gray-600 fw-500"> {{$t(`비밀번호 변경`)}} </b-td>
                    <b-td> <b-button @click="toggleChangePassword()" variant="dark" block v-if="is_password_change==false"> {{$t(`비밀번호 변경`)}}</b-button>
                        <b-button @click="toggleChangePassword()" variant="dark" block v-else> {{$t(`비밀번호 변경 취소`)}}</b-button></b-td>
                </b-tr>
                <b-tr v-if="is_password_change">
                    <b-td class="gray-600 fw-500"> {{$t(`기존 비밀번호`)}} </b-td>
                    <b-td><b-form-input type='password' v-model="password_old" :placeholder="$t(`기존 비밀번호를 입력해 주세요`)" :aria-label="$t(`기존 비밀번호`)" autocomplete="current-password"></b-form-input></b-td>
                </b-tr>
                <b-tr v-if="is_password_change">
                    <b-td class="gray-600 fw-500"> {{$t(`새 비밀번호`)}} </b-td>
                    <b-td><b-form-input type='password' v-model="password_new1" :placeholder="$t(`4자리 이상 입력해 주세요`)" :aria-label="$t(`새 비밀번호`)" autocomplete="new-password"></b-form-input>
                        <div class="f-90 text-left red">{{ passwordLengthCheck }}</div>
                    </b-td>
                </b-tr>
                <b-tr v-if="is_password_change">
                    <b-td class="gray-600 fw-500"> {{$t(`새 비밀번호 확인`)}} </b-td>
                    <b-td><b-form-input type='password' v-model="password_new2" :placeholder="$t(`새 비밀번호를 한번 더 입력해 주세요`)" :aria-label="$t(`새 비밀번호 확인`)" autocomplete="new-password"></b-form-input>
                        <div class="f-90 text-left red">{{ passwordLengthAlign }}</div>
                    </b-td>
                </b-tr>
                </b-tbody>
            </b-table-simple>

        <div class="mb-2 d-md-flex justify-content-between align-items-top">
            <div :class="validation_style"><fa :icon="validation_icon" v-if="validation_icon !=''"></fa> {{ validation_comment }} </div>
            <b-button v-if="load_failed" variant="dark" @click="initiateData"> {{$t(`다시 시도`)}} </b-button>
            <b-button v-else type="submit" variant="blue" :disabled="!is_loaded || is_saving"> {{$t(`저장`)}} </b-button>
        </div>
        </b-form>
    </b-container>
</template>


<script>
import { getErrorMessage } from '@core/utils/api/errorMessage'

export default {
    name: "UserInfo",
    data () {
        return {
            question_name: this.$t('기업 기본정보'),
            question_infobox: this.$t('아래의 기업 기본정보를 입력하여 주십시오'),

            tel_office: '',
            tel_mobile: '',
            address: '',
            headquarter_address:'',
            department_name:'',

            is_loaded: false,
            load_failed: false,
            is_saving: false,

            save_state: 'not_saved',
            save_icon: '',
            save_validation: '',

            validation_comment: '',
            validation_icon: '',
            validation_style: 'ih-validation-saved',

            is_password_change: false,

            password_old: '',
            password_new1: '',
            password_new2: ''
        }
    },
    computed: {
        user_name() {
            return this.$store.getters.getUserName
        },
        company_name() {
            return this.$store.getters.getCompanyName
        },
        company_id() {
            return this.$store.state.company_id
        },
        is_admin() {
            return this.$store.state.is_admin
        },
        e_mail() {
            return this.$store.getters.getEMail
        },
        passwordLengthCheck () {
            if (this.password_new1 !== '') {
                return this.password_new1.length > 3
                    ? ''
                    : this.$t('비밀번호는 4자리 이상 입력해주세요')
            } else {
                return null
            }
        },
        passwordLengthAlign () {
            if (this.password_new2 !== '') {
                return this.password_new1 === this.password_new2
                    ? ''
                    : this.$t('패스워드가 일치하는지 확인해 주세요')
            } else {
                return null
            }
        }
    },
    watch: {
        save_state (_state) {
            if (_state == 'saving') {
                this.validation_comment = this.$t('저장 중입니다.')
                this.validation_icon = 'hourglass'
                this.validation_style = 'ih-validation-saving'
            } else if (_state == 'saved') {
                this.validation_comment = this.$t('저장 되어있습니다')
                this.validation_icon = 'check'
                this.validation_style = 'ih-validation-saved'
            } else if (_state == 'not_saved') {
                this.validation_comment = ''
                this.validation_icon = ''
            } else if (_state == 'resaved') {
                this.validation_comment = this.$t('변경 저장 되었습니다')
                this.validation_icon = 'check'
                this.validation_style = 'ih-validation-resaved'
            }
        }
    },
    async created () {
        await this.initiateData()
    },
    methods: {
        async initiateData () {
            try {
                const response = await this.$axios.get('/read_user', {
                    params: { e_mail: this.$store.getters.getEMail }
                })
                let result = response.data
                // null 을 그대로 두면 저장 때 FormData 가 문자열 "null" 로 보낸다
                this.tel_office = result.tel_office || ''
                this.tel_mobile = result.tel_mobile || ''
                this.address = result.address || ''
                this.headquarter_address = result.headquarter_address || ''
                this.department_name = result.department_name || ''
                this.save_state = ''
                this.load_failed = false
                this.is_loaded = true
                this.validation_comment = ''
                this.validation_icon = ''

            } catch (error) {
                this.save_state = 'not_saved'
                this.load_failed = true
                this.validation_comment = this.$t('정보를 불러오지 못했습니다. 다시 시도해 주세요.')
                this.validation_icon = ''
                this.validation_style = 'ih-validation-saving'
                console.log(error)
            }
        },
        async handleOK () {
            if (this.is_password_change) {
                //1) 패스워드 체크: 기존 패스워드 입력했는지? 
                if (this.password_old === '') {
                    this.$EventBus.$emit('toast-warning', this.$t('알림'), this.$t('기존 비밀번호를 입력해 주세요'))
                    return false
                }

                //2) 패스워드 신규 2개가 일치하는지?
                if (this.password_new1 === '' || this.password_new1 !== this.password_new2) {
                    this.$EventBus.$emit('toast-warning', this.$t('알림'), this.$t('변경할 비밀번호를 다시 확인해 주세요'))
                    return false
                }

                //3) 새 비밀번호 길이 (입력칸 아래 안내와 같은 기준)
                if (this.password_new1.length < 4) {
                    this.$EventBus.$emit('toast-warning', this.$t('알림'), this.$t('비밀번호는 4자리 이상 입력해주세요'))
                    return false
                }

                //4) 기존 패스워드와 신규 패스워드가 다른지?
                if (this.password_old === this.password_new1) {
                    this.$EventBus.$emit('toast-warning', this.$t('알림'), this.$t('기존 비밀번호와 변경할 비밀번호가 동일합니다. 다시 확인해 주세요.'))
                    return false
                }
            }
            // console.log(this.password_old);

            await this.userSave()
        },
        userSave: async function () {
            this.is_saving = true
            this.save_state = 'saving'
            try {
                const formData = new FormData()
                formData.append('is_password_change', this.is_password_change)
                formData.append('password_old', this.password_old)
                formData.append('password_new', this.password_new1)

                formData.append('user_name', this.user_name)
                formData.append('company_id', this.company_id)
                formData.append('company_name', this.company_name)
                formData.append('e_mail', this.e_mail)
                formData.append('tel_office', this.tel_office)
                formData.append('tel_mobile', this.tel_mobile)
                formData.append('address', this.address)
                //formData.append('headquarter_address', this.headquarter_address)
                formData.append('department_name', this.department_name)
                formData.append('is_admin', this.is_admin)

                const _res_update = await this.$axios.post('/users', formData)
                const _updated = _res_update.data
                if ((_updated['result_code'] && _updated['result_code'] === 'error') || (_updated["code"] && _updated['code'] === 'error')) { 
                    this.save_state = 'not_saved'
                    this.$EventBus.$emit('toast-failure', this.$t('알림'), _updated['result_msg'] ? this.$t(_updated['result_msg']) : this.$t('정보 수정 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.'))
                } else {
                    this.$EventBus.$emit('toast-success', this.$t('알림'), this.$t('수정을 완료하였습니다.'))
                    this.$nextTick(() => {
                        this.$emit('user-save')
                        this.save_state = 'resaved'
                    })
                }
            } catch (error) {
                console.log(error)
                this.save_state = 'not_saved'
                if (error.response && error.response.status === 401) return // 인터셉터가 로그인으로 보낸다
                this.$EventBus.$emit('toast-failure', this.$t('알림'), getErrorMessage(error, this.$t('정보 수정 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.')))
            } finally {
                this.is_saving = false
            }
        },
        toggleChangePassword(){
            this.is_password_change = !this.is_password_change
        }
    }
}
</script>

<style scoped>

.company_info{
    margin-top: 80px;
}

.my-info-h{
    min-height: 38px;
}

.ih-validation-saved {
    color: var(--green);
    font-size: 0.9rem;
}

.ih-validation-saving {
    color:var(--red);
    font-size: 0.9rem;
}

.ih-validation-resaved {
    color: var(--green);
    font-size: 0.9rem;
}

.user-info-bg {
    left: 0;
    top: 0;
    height: 100vh;
    width: 100vw;
    overflow: none;
    background-color: var(--light);
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-repeat: no-repeat;
    z-index: 1;
    overflow: hidden;
}

 @media (max-width:736px) {
    #user-info-box {
        max-width: 90vw;

    }
}



</style>
